import { ApiAuthAppSessionRefv2IntentSchema } from "@bridge-applications/eh-types";
import { z } from "zod";
import { NS2 } from "../../state/config";

export const REFV2_CAMPAIGN_ID = "e4d95fd7-d95b-48bd-9347-af5c9621848f";

const REFV2_INTENT_STORAGE_KEY = `${NS2}refv2Intent`;

export type Refv2Intent = z.infer<typeof ApiAuthAppSessionRefv2IntentSchema>;

export function normalizeRefv2InviteCode(input: string): string {
    return input
        .replace(/[^a-z0-9]/gi, "")
        .toUpperCase()
        .slice(0, 5);
}

function parseRefv2Intent(value: unknown): Refv2Intent | null {
    const parsed = ApiAuthAppSessionRefv2IntentSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
}

export function readPendingRefv2Intent(): Refv2Intent | null {
    try {
        const raw = localStorage.getItem(REFV2_INTENT_STORAGE_KEY);
        if (!raw) return null;

        const intent = parseRefv2Intent(JSON.parse(raw));
        if (!intent) localStorage.removeItem(REFV2_INTENT_STORAGE_KEY);
        return intent;
    } catch {
        localStorage.removeItem(REFV2_INTENT_STORAGE_KEY);
        return null;
    }
}

export function clearPendingRefv2Intent() {
    try {
        localStorage.removeItem(REFV2_INTENT_STORAGE_KEY);
    } catch {
        // do nothing
    }
}

export function captureRefv2IntentFromUrl(
    urlString = window.location.href,
): Refv2Intent | null {
    try {
        const url = new URL(urlString);
        const rawCode = url.searchParams.get("refv2");
        if (!rawCode) return readPendingRefv2Intent();

        const intent = parseRefv2Intent({
            campaignId: REFV2_CAMPAIGN_ID,
            inviteCode: normalizeRefv2InviteCode(rawCode),
        });
        if (!intent) return readPendingRefv2Intent();

        localStorage.setItem(REFV2_INTENT_STORAGE_KEY, JSON.stringify(intent));
        return intent;
    } catch {
        return readPendingRefv2Intent();
    }
}
